import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCwixh5wtjPMPdggFIe-Z2kcybx8vFNjZo",
  authDomain: "whatsapp-mern-bac30.firebaseapp.com",
  databaseURL: "https://whatsapp-mern-bac30.firebaseio.com",
  projectId: "whatsapp-mern-bac30",
  storageBucket: "whatsapp-mern-bac30.appspot.com",
  messagingSenderId: "482368011814",
  appId: "1:482368011814:web:1381e8a38a1f775e6f30e7",
  measurementId: "G-X3TJVP5NCS"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
